import { useState, useEffect } from 'react';

export const useResponsiveLayout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);
  const [viewportWidth, setViewportWidth] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(0);

  useEffect(() => {
    const checkLayout = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const mobile = width < 768;
      const landscape = height < width;

      setViewportWidth(width);
      setViewportHeight(height);
      setIsMobile(mobile);
      setIsLandscape(landscape);
    };

    checkLayout();
    window.addEventListener('resize', checkLayout);
    window.addEventListener('orientationchange', checkLayout);

    return () => {
      window.removeEventListener('resize', checkLayout);
      window.removeEventListener('orientationchange', checkLayout);
    };
  }, []);

  return {
    isMobile,
    isLandscape,
    isTablet: !isMobile && viewportWidth < 1024,
    isDesktop: viewportWidth >= 1024,
    viewportWidth,
    viewportHeight,
    breakpoint: isMobile ? 'mobile' : viewportWidth < 1024 ? 'tablet' : 'desktop',
  };
};
